import Theme from "../../../../../utils/Theme";

export const SalesAidsStyles = {
  accordiansBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "scroll",
    height: "100%",
  },
  artifactBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 2,
    alignItems: "center",
    width: "100%",
    height: "100%",
  },

  doneAll: {
    fontSize: "medium",
    color: Theme.palette.primary.main,
    cursor: "pointer",
  },

  addNewBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  appButtonBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    // p: 1,
    gap: 1,
  },
  surveyButtonBox: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    p: "0px 37px 0px 37px",
  },
  surveyButtonInsideBox: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
  },

  reviewLinkBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 2,
    alignItems: "center",
    p: "20px 8px 8px 8px",
  },
  artifactGrid: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 1,
    alignItems: "center",
  },
  engagementLinkBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 2,
    alignItems: "center",
    p: "20px 8px 8px 8px",
    width: "100%",
  },
  engagementGrid: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: 1,
    alignItems: "center",
    width: "100%",
  },

  abcIcon: {
    backgroundColor: "#F5F5F5",
    borderRadius: "50%",
    marginRight: "15px",
    fontSize: "19px",
  },
  accordianSummary: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  chevronArrow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "10%",
    color: "gray",
    height: "10%",
  },
  sucessBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    my: "14px",
    width: "100%",
  },
  enablemessage: {
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    pt: "20px",
  },
  artifactSentence: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "5px",
  },
  executionOutsideBox: {
    display: "flex",
    flexDirection: "column",
    // gap: "3%",
    width: "33%",
    height: "100%",
    justifyContent: "space-between",
    alignItems: "start",

  },
  executionButton: {
    width: "100%",
    justifyContent: "space-center",
    alignItems: "center",
    // height: "10%",
    px: 1,
    gap: "20px",
  },
  executionBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "87%",
  },
  orderOutside: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowY: "scroll",
    px: 1,
  },
  orderInsideBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: 1,
    width: "100%",
    alignItems: "center",
  },
  orderContentBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: "90%",
    p: "5px",
  },
  arraowBack: {
    fontSize: "19px",
    cursor: "pointer",
    color: Theme.palette.error.main,
    alignSelf: "center",
    pl: "5px",
  },

  //Artifacts...

  outerBox: { display: "flex", flexDirection: "column" },
  innerBox: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
    p: "6px",
    borderRadius: 2,
    alignItems: "flex-start",
  },
  subheadingBox: { flex: 1, display: "flex", flexDirection: "column", gap: 2 },
  wordStyle: { fontSize: 15, fontWeight: "bold", color: "gray" },
  arrowForward: {
    fontSize: "small",
    color: Theme.palette.primary.main,
    mt: 4,
    alignSelf: "center",
  },
  doneIcon: {
    fontSize: 20,
    mt: 4,
    alignSelf: "center",
  },
  closeIcon: {
    fontSize: "small",
    color: "red",
    cursor: "pointer",
    alignSelf: "center",
    mt: 4,
  },
  surveyButton: {
    fieldset: {
      borderColor: Theme.palette.primary.main,
    },
    "&:hover fieldset": {
      borderColor: Theme.palette.primary.main + "!important",
    },
    "& .MuiOutlinedInput-input": {
      color: Theme.palette.primary.main,
    },
    backgroundColor: "transparent",
    width: "100%",
  },

  videoOuterBox: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: 1,
  },
  twofields: { mt: 1 },

  reviewBox: {
    display: "flex",
    flexDirection: "row",
    gap: 2,
    alignItems: "center",
  },
};
